import { PublicationContentType } from '@app/entities/enums/multimedia/content-status-types.enum';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

import { ImagePublication } from './image.model';
import { InternalLink } from './internal-link.model';
import { MultimediaPublication } from './multimedia-detail.model';
import { News } from './news.model';
import { Publication } from './publication.model';
import { TextPublication } from './text.model';
import { VideoPublication } from './video.model';

export class MultimediaFactory {
  static createPublication(item: MSafeAny): Publication {
    switch (item.content_type) {
      case PublicationContentType.NEWS:
        return new News(item);
      case PublicationContentType.IMAGE:
        return new ImagePublication(item);
      case PublicationContentType.VIDEO:
        return new VideoPublication(item);
      case PublicationContentType.INTERNAL:
        return new InternalLink(item);
      case PublicationContentType.MULTIMEDIA:
        return new MultimediaPublication(item);
    }
    return new TextPublication(item);
  }
}
